import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Container,
    HStack,
    IconButton,
    Tooltip,
    useToast,
    VStack
} from '@chakra-ui/react';
import React from 'react';
import { FiArrowLeft, FiRefreshCw } from 'react-icons/fi';
import { Link as RouterLink } from 'react-router-dom';
import AccessExport from '../../components/AccessExport';
import AccessFilters from '../../components/AccessFilters';
import AccessList from '../../components/AccessList';
import { useAccessList } from '../../hooks/useAccessList';

const AccessListPage: React.FC = () => {
  const {
    acessos,
    loading,
    loadingMore,
    error,
    hasMore,
    total,
    filters,
    handleLoadMore,
    handleFilter,
    handleClearFilters,
    refresh
  } = useAccessList();

  const toast = useToast();

  const handleRefresh = () => {
    refresh();
    toast({
      title: 'Lista atualizada',
      description: 'Os dados foram recarregados com sucesso',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
  };

  return (
    <Container maxW="8xl" py={8}>
      {/* Breadcrumb e Ações */}
      <HStack justify="space-between" mb={6}>
        <Breadcrumb>
          <BreadcrumbItem>
            <BreadcrumbLink as={RouterLink} to="/admin">
              Admin
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink>Acessos Realizados</BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>

        <HStack spacing={2}>
          <Tooltip label="Atualizar lista">
            <IconButton
              aria-label="Atualizar lista"
              icon={<FiRefreshCw />}
              variant="outline"
              onClick={handleRefresh}
              isLoading={loading}
            />
          </Tooltip>
          <Tooltip label="Voltar ao Dashboard">
            <IconButton
              aria-label="Voltar ao Dashboard"
              icon={<FiArrowLeft />}
              variant="outline"
              as={RouterLink}
              to="/admin"
            />
          </Tooltip>
        </HStack>
      </HStack>

      {/* Conteúdo Principal */}
      <VStack spacing={6} align="stretch">
        {/* Filtros */}
        <AccessFilters
          filters={filters}
          onFilter={handleFilter}
          onClearFilters={handleClearFilters}
          totalRecords={total}
          currentRecords={acessos.length}
          isLoading={loading}
        />

        {/* Exportação de Acessos */}
        <AccessExport />

        {/* Lista de Acessos */}
        <AccessList
          acessos={acessos}
          loading={loading}
          loadingMore={loadingMore}
          hasMore={hasMore}
          error={error}
          onLoadMore={handleLoadMore}
          onRefresh={handleRefresh}
        />
      </VStack>
    </Container>
  );
};

export default AccessListPage; 